// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__q6sT0","modern":"Icon_modern__eStFC","legacy":"Icon_legacy__0I5O0","legacy--base":"Icon_legacy--base__4IXvZ"};